import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0085 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="「働き方」の次は「休み方」！「休み方改革」とは？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.10.23</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        働き方とセットとして考えるべきものが休み方です。AIとは異なり人間である以上、年中働くことは不可能であり、一定の休息が必要です。その中で注目されているのか休み方改革です。休み方改革といっても企業規模や業種ごとに取り組み可能な施策は異なりますが、今回は休み方改革にフォーカスをあて解説します。
      </p>
      <img src="/images/column/details/c0085.jpg" alt="キンクラコラム画像85" />
      <div id="toc1">
        <h1>休み方改革とは</h1>
      </div>
      <p>
        端的には
        <span>労働者が休みやすい環境をつくるための施策</span>
        と解されます。前提として、
        <span>諸外国に比べて日本は労働時間が長いことで知られています</span>
        。必然的に睡眠時間も短いことで知られ、労働生産性だけでなく、健康面でも何らかの対策が必要です。長く働くことが求められている現代においては
        <span>
          働き方だけでなく、休み方についても本腰を入れて考える必要があります
        </span>
        。
        <br />
        <br />
        以前は長い時間会社にいる者が評価される（結果的に昇進もする）という時代もありましたが、時代の変化が訪れ、そのような働き方が正解という風土はなくなりつつあります。もちろん、繁忙期については
        <span>
          一定時間以上の時間外労働は必要と考えますが、恒常的にそのような状態になっているということは、そもそも仕事の割り振りや人員体制に支障をきたしている可能性が高いと言え、何らかの変革が求められます
        </span>
        。
        <br />
        <br />
        まず、休み方改革として多くの事業所で取り組みやすい具体的な手法は有給休暇の取得促進です。雇用契約の元に労務提供する労働者が存在する限り、労働基準法で規定する有給休暇も当然存在します。もちろん、出勤率が著しく低いがゆえに有給休暇が発生していない労働者が存在することもあり得ますが、多くの企業で有給休暇を全て活用しているというケースは決して多くありません。部門ごとにより積極的に取得が可能な時季な時期を洗い出し、個々の労働者に対して上長が積極的に呼びかけることも一つの案です。
      </p>

      <div id="toc2">
        <h1>休み方改革のメリット</h1>
      </div>
      <p>
        労使双方でのメリットとなりますが、<span>「生産性の向上」</span>
        が挙げられます。もちろん繁忙期に積極的に休むということは適切ではありませんが、
        <span>
          繁忙期を迎える前に休暇を通じて英気を養い、来るべき繁忙期に備えるという考え方は適切
        </span>
        と言えます。また、上司が有給休暇をほとんど取得していない場合、部下目線では積極的に有給休暇が取得しづらいという声があります。逆に上司が積極的に有給休暇を取得することで
        <span>副次的に部下も有給休暇を取得しやすい風土が醸成され</span>
        、離職率の防止（休みづらい企業よりは休みやすい企業に魅力を感じる場合は特に）にも寄与します。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>休み方改革のデメリット</h1>
      </div>
      <p>
        労働者目線でのデメリットとして、<span>「残業代が減る」こと</span>
        です。言うまでもなく、有給休暇は給与が保障された状態で労務提供が免除されますが、残業代が支給されることはあり得ません。もちろん繁忙期に有給休暇を取得し、本来出勤していれば残業していたことがほぼ確実であったとしても実際に残業しているわけではありませんので、有給休暇を取得した日に残業代が支給されることはありません。
        <br />
        <br />
        次に会社側のデメリットとしては労働者側のデメリットと類似のデメリットですが、
        <span>
          「残業代目当て」であっても仕事を確実にこなしてくれる労働者の離職の誘因になり得ること
        </span>
        です。休み方改革を通じて、手取り収入が減ることで生活へのマイナス面が気がかりとなり、離職されてしまうと再度人材募集から育成への手間が生じます。ただし、
        <span>
          「残業代目当て」で離職するというのは本来褒められる理由とは言えず、長期的な意味ではデメリットにならない
          ことも考えられます。
        </span>
      </p>

      <div id="toc4">
        <h1>休み方改革の施策</h1>
      </div>
      <p>
        <span>
          プラスワン休暇と称し、土曜日・日曜日が休日の企業の場合、更に月曜日や金曜日にも休暇を付与すること
        </span>
        です。この施策によって事実上「3連休」となり、通常の週末ではできないこと（例えば旅行）を取り組め、それが創造力の喚起等、仕事にも反映すれば決してマイナスとは言えません。もちろん毎週の実施は現実的ではありませんが、年間52週の中で特定の週のみ実施するということであればそこまで無理難題ではないでしょう。また、このような施策の導入により、
        <span>
          労働者の帰属意識の向上も期待され、ひいては離職率の低下にも繋がる期待が持てます。
        </span>
      </p>

      <div id="toc5">
        <h1>企業の事例</h1>
      </div>
      <p>
        誕生日休暇や結婚記念日休暇等、労働者の個別の事情を汲んだ休暇の設定です。仮に設定したとしても理論上、年間の中で各1日ずつであり、そこまで労務管理上大きな支障をきたさないことからも導入される事例は少なくありません。肝心な賃金支給の回避ついては無論法律で明記されている労働基準法上の年次有給休暇とは別の制度であるため、無給とすることは差し支えありません。ただし、無給としてしまうと事実上、欠勤と何ら変わらず、設ける実益がほぼないため、取得が進まない可能性も孕んでいます。
      </p>

      <div id="toc6">
        <h1>最後に</h1>
      </div>
      <p>
        休み方改革は働き方改革に比べて聞きなれないフレーズと思われます。ただし、「働きすぎ」と言われる日本においては働き方改革と並び重要な意味を持つ施策です。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0085
